import { VFC } from 'react'
import { Routes, Route } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'

import OngoingWorkflowContainer from './OngoingWorkflow/Container'

const WorkflowRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path=':workflowUuid' element={<OngoingWorkflowContainer />} />
      </Route>
    </Routes>
  )
}

export default WorkflowRoutes
